
import { reactive } from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "RegistrationFishingData",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "",
      form: "RegistrierungBenutzer",
      page: "RegistrierungFischerei",
      remoteId: "",
      
      
    });

    return {
      request,
    };
  }
};
